import script from "./NewsSubscription.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsSubscription.vue?vue&type=script&setup=true&lang=js"

import "./NewsSubscription.vue?vue&type=style&index=0&id=2ce0923e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce0923e"]])

export default __exports__